import { groupBy } from "lodash";
import { SkillImportance, SkillsFramework } from "PFTypes";
import { useMemo, useState } from "react";

export const useSkillsFrameworkModal = (skillsFramework?: SkillsFramework | null) => {
  const [selectedFramework, setSelectedFramework] = useState<SkillsFramework | null>(skillsFramework || null);

  const essentialSkills = useMemo(
    () =>
      selectedFramework?.skills.filter(({ importance }) => importance === SkillImportance.Essential) || [],
    [selectedFramework]
  );

  const supportingSkills = useMemo(
    () =>
      selectedFramework?.skills.filter(({ importance }) => importance === SkillImportance.Supporting) || [],
    [selectedFramework]
  );

  const customTypesWithValues = useMemo(() => {
    const groupedById = groupBy(selectedFramework?.customFields || [], (field) => field.customType.id);
    return Object.values(groupedById).map((values) => ({
      type: values[0].customType,
      values: values.map(({ customValue }) => customValue)
    }));
  }, [selectedFramework]);

  return {
    essentialSkills,
    supportingSkills,
    customTypesWithValues,
    selectedFramework,
    setSelectedFramework
  };
};
